import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import vSelect from 'vue-select';
import App from './App.vue';
import router from './router';
import store from './store';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import axios from 'axios';
import moment from 'moment-timezone';
import { loadCurrentUser } from '@/utils/storage';
import VueHtml2Canvas from 'vue-html2canvas';
import EventBus from '@/helpers/EventBus.js';

// Package configurations
import '@/config/firebase/firebase.js';
import '@/config/vee_validate/vee_validate.js';

// Libraries
import '@/utils/logger.js';

// import mixins
import '@/mixins/object.js';

// Style Sheets
import 'nprogress/nprogress.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/stylesheets/app.scss';
import '@/assets/font-icons/css/fontello.css';
import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;
Vue.config.stagingBuild = process.env.VUE_APP_STAGING_BUILD == 'true';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueHtml2Canvas);
Vue.component('v-select', vSelect);

// Set default timezone to Asia/Tokyo
moment.tz.setDefault('Asia/Tokyo');

const requireComponent = require.context('./components', false, /Base[A-Z]\w+\.(vue|js)$/);
requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1')));

  Vue.component(componentName, componentConfig.default || componentConfig);
});

router.beforeEach((to, from, next) => {
  const authenticate_routes = ['login', 'login_teacher', 'login_corporation_brand_school', 'tamaishiki_private'];
  if (authenticate_routes.includes(to.name)) {
    return next();
  }

  // Ensure all request in authenticated (include case go back)
  if (loadCurrentUser()) {
    // After browser refresh, make sure current user data has
    if (store.getters['role/currentUserProfileFetched']) {
      next();
    } else {
      Vue.$logger.debug('[APP] Waiting app fetching Current User Profile');
      EventBus.$on('SET_USER_PROFILE', next);

      // Avoid UI crash when event SET_USER_PROFILE doesn't trigger.
      setTimeout(next, 3000);
    }
  } else {
    next({ name: 'login' });
  }
});

new Vue({
  router,
  store,
  created() {
    // Catch all axios error response
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        return new Promise((resolve, reject) => {
          // Status code is 401, that is unauthorized request or token is invalid
          if (error.response.status === 401) {
            this.$logger.debug('[AXIOS INTERCEPTORS] [401] - Force Logout!!!');
            this.$store.dispatch('auth/logout');

            // Redirect to login page
            if (this.$route.fullPath.indexOf('login') < 0 && this.$route.fullPath.indexOf('tamaishiki_private') < 0) {
              if (error.response.data.error == 'Account is frozen') {
                alert('このアカウントは現在利用できません');
              }
              this.$router.push({ name: 'login' });
            }
          }
          reject(error);
        });
      }
    );

    let userData = loadCurrentUser();
    if (userData && userData.token) {
      this.$store.dispatch('auth/restoreSession');
      this.$store.dispatch('auth/verifySession');
    } else {
      this.$logger.debug('[APP]', 'No previous session found!');
      if (this.$route.fullPath.indexOf('login') < 0 && this.$route.fullPath.indexOf('tamaishiki_private') < 0) {
        this.$router.push({ name: 'login' });
      }
    }
  },
  render: (h) => h(App),
}).$mount('#app');
